import { h } from 'preact';

// See http://webaim.org/techniques/css/invisiblecontent/#absolutepositioning
export default function ScreenReaderText({ children, ...props }) {
	return (
		<div {...props} style={'position:absolute; left:-10000px; top:auto; width:1px; height:1px; overflow:hidden;'}>
			{children}
		</div>
	);
}

